export default __webpack_public_path__ + "static/media/039-fox.ef86a571.svg";